module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_04-fe5c25a45e83bcc3dcc106a3bd2c753f.jpg";